import { render, staticRenderFns } from "./ReportMealsTabGroceries.vue?vue&type=template&id=c1e0a1c6"
import script from "./ReportMealsTabGroceries.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabGroceries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports